export default __webpack_public_path__ + "static/media/Jasmine 9781843628248.7c4071ed.jpg";